import LoadPosts from "./LoadPosts";

export default {
    init() {

        if (document.querySelector('.grid--infinite-load')) {
            Array.from(document.querySelectorAll('.grid--infinite-load'))
                .forEach(el => new LoadPosts(el));
        }
    }
}
